module.exports = __webpack_public_path__ + "img/IONIQ5.120e2e1b.png";